/**
 * UrlImportTab Component
 * Tab content for importing URL-based documents
 * Pure presentational component
 */

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, TextField, Typography } from '@mui/material';
import { UrlImportTabProps } from '../types';

export const UrlImportTab: React.FC<UrlImportTabProps> = ({
  value,
  onChange,
  error
}) => {
  const { t } = useTranslation();

  return (
    <Box>
      <TextField
        required
        fullWidth
        label={t('documents.dialog.url')}
        name="url"
        value={value}
        onChange={onChange}
        helperText={error || t('documents.dialog.urlHelp')}
        error={!!error}
      />
      <Typography variant="caption" sx={{ display: 'block', mt: 2, color: 'text.secondary' }}>
        {t('documents.upload.urlInfo')}
      </Typography>
    </Box>
  );
};
